var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["mds-notification-container"],
        _vm.classObject,
        _vm.positionClass,
        _vm.widthClass,
      ],
      attrs: {
        "data-mds-version": _vm.version,
        "aria-live": _vm.ariaLive,
        role: "status",
      },
    },
    [
      _c(
        "transition-group",
        {
          attrs: {
            "enter-active-class":
              _vm.$style["mds-notification-container--enter-active"],
            "leave-active-class":
              _vm.$style["mds-notification-container--leave-active"],
            tag: "div",
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }